import React from "react";
// react-router-dom
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilValue } from "recoil";
// @Mui
import { Box, Button, Stack, Typography } from "@mui/material";
// atoms
import { fillFormStatusAtom } from "src/recoil";
// paths
import { PATH_DASHBOARD } from "src/routes/paths";
// hooks
import useLocales from "src/hooks/useLocales";
//
import Iconify from "./Iconify";

// ----------------------------------------------------------------------------------------------

function ProgramAvailablity({ children }) {
  const fillFormStatus = useRecoilValue(fillFormStatusAtom);

  const noPrograms = fillFormStatus.fill_form && fillFormStatus.initial_form;

  const { translate } = useLocales();

  const navigate = useNavigate();

  return (
    <Box>
      {noPrograms ? (
        <Stack alignItems="center" justifyContent="center">
          <Box
            sx={{ width: 500 }}
            component="img"
            src="/assets/no-programs.png"
          />
          <Typography variant="h2">
            {translate(
              "pagesTranslations.programAvailabilityPageTranslations.title"
            )}
          </Typography>
          <Typography variant="subtitle1">
            {translate(
              "pagesTranslations.programAvailabilityPageTranslations.description"
            )}
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{ mt: 4 }}
            onClick={() => navigate(PATH_DASHBOARD.algorithmForm)}
            endIcon={<Iconify icon="solar:alt-arrow-right-broken" />}
          >
            {translate(
              "pagesTranslations.programAvailabilityPageTranslations.action"
            )}
          </Button>
        </Stack>
      ) : (
        children
      )}
    </Box>
  );
}

export default ProgramAvailablity;
